import styled from "styled-components";

export const TimeRangeDisplayStyled = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: var(--allie-spacing-xxs);
`;
